/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/axiosInstance.js";
import type { UpdateSession1MutationRequest, UpdateSession1MutationResponse, UpdateSession1PathParams, UpdateSession1400, UpdateSession1401, UpdateSession1403, UpdateSession1404, UpdateSession1409, UpdateSession1500 } from "../../types/UpdateSession1.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/axiosInstance.js";

function getUpdateSession1Url(sessionId: UpdateSession1PathParams["sessionId"]) {
  const res = { method: 'PATCH', url: `/api/research-chat/${sessionId}` as const }
  return res
}

/**
 * @description Updates the session properties such as title.
 * @summary Update a chat session
 * {@link /api/research-chat/:sessionId}
 */
export async function updateSession1(sessionId: UpdateSession1PathParams["sessionId"], data: UpdateSession1MutationRequest, config: Partial<RequestConfig<UpdateSession1MutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<UpdateSession1MutationResponse, ResponseErrorConfig<UpdateSession1400 | UpdateSession1401 | UpdateSession1403 | UpdateSession1404 | UpdateSession1409 | UpdateSession1500>, UpdateSession1MutationRequest>({ method : "PATCH", url : getUpdateSession1Url(sessionId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}